// extracted by mini-css-extract-plugin
export default {"shelf":"social-skeletons-ShelfLoadingSkeleton__shelf--o9OIO"};